export const PUBLIC_SEARCH_COOKIE = 'publicSearchTerms'
